<div>
    <div class="heading">
        <h3>View Assigned Technician</h3>
        <span (click)="onNoClick()"><mat-icon>close</mat-icon></span>
     </div>
     <div class="body-user">
        <!-- <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
        style="margin-bottom: 20px;align-items: baseline;"> -->
        <div class="scroll">
          <div class="information_section">
            <div>
              <h3>Company Details</h3>
              <ul>
                <li>
                  <label>Company Name: </label>
                  <span>{{technicianDetails?.assignedCompany?.companyName}}</span>
                </li>
                <li>
                  <label>Company Phone Number: </label>
                  <span>{{technicianDetails?.assignedCompany?.companyPhone | mask : "(000) 000-0000"}}</span>
                </li>
                <li>
                  <label>Company Email Address: </label>
                  <span>{{technicianDetails?.assignedCompany?.companyEmail}}</span>
                </li>
              </ul>
              <ul>
                <div *ngIf="technicianDetails?.assignedCompany?.trades?.length > 0">
                  <h3>Trades</h3>
                  <div class="item_list">
                    <span *ngFor="let item of technicianDetails?.assignedCompany?.trades">{{item?.title}}</span>
                  </div>
                </div>
              </ul>
            </div>
            <div>
              <h3>Technician Details</h3>
              <ul *ngIf="technicianDetails?.assignedTechnician">
                <li>
                  <label>Technician First Name: </label>
                  <span>{{technicianDetails?.assignedTechnician?.firstName}}</span>
                </li>
                <li>
                  <label>Technician Last Name: </label>
                  <span>{{technicianDetails?.assignedTechnician?.lastName}}</span>
                </li>
                <li>
                  <label>Technician Phone Number: </label>
                  <span>{{technicianDetails?.assignedTechnician?.phoneNumber | mask : "(000) 000-0000"}}</span>
                </li>
                <li>
                  <label>Technician Email Address: </label>
                  <span>{{technicianDetails?.assignedTechnician?.emailAddress}}</span>
                </li>
                <li *ngIf="technicianDetails?.assignedTechnicianDatetime">
                  <label>Technician Schedule Date: </label>
                  <span>{{technicianDetails?.assignedTechnicianDatetime | date : "MMM-dd-YYYY h:mm a"}}</span>
                </li>
              </ul>
              <p class="red" *ngIf="!technicianDetails?.assignedTechnician && !isFetchingData">No technician assigned to this claim.</p>
            </div>
          </div>
          <div class="form_section" *ngIf="technicianDetails?.assignedTechnician">
            <form [formGroup]="serviceStatusForm">
              <h3>Change Service Status</h3>
              <mat-form-field appearance="outline">
                <mat-label>Service Status</mat-label>
                <mat-select formControlName="serviceStatus">
                  <mat-option *ngFor="let status of serviceStatus" [value]="status">
                    {{status}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </div>
        </div>
        
      <!-- </fxLayout> -->
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button class="sub-button" (click)="changeServiceStatus(submitType.changeStatus)" *ngIf="technicianDetails?.assignedTechnician && !isLoading"><span>Change</span></button>
        <button mat-button class="assign-button" (click)="changeServiceStatus(submitType.assignOrEditTechnician)" *ngIf="!isLoading"><span>Assign Technician</span></button>
        <button mat-button class="assign-button" (click)="changeServiceStatus(submitType.addTechnicianSchedule)" *ngIf="!isLoading"><span>Schedule Technician</span></button>
        <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()" *ngIf="!isLoading"><span>Close</span></button>
        <img src="https://cdn.elitehw.com/images/loder.gif" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
    </div>
     </div>
</div>
